import { Button, Grid, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { toolTypologySchema } from '../ToolTypologyDetailsContext';
import * as yup from 'yup';
import { Link as RouterLink, useLocation } from 'react-router-dom';


let ToolTypologyForm = () => {
    let router = useLocation();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'Nuova Tipologia' : `Modifica Tipologia`;

    type ToolTypology = yup.InferType<typeof toolTypologySchema>;
    let form = useFormikContext<ToolTypology>();


    return (
        <Form>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="name"
                        label="Nome"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControlLabel
                        label="Necessita di Manutenzione"
                        name="needMaintenance"
                        value={form.values.needMaintenance}
                        checked={form.values.needMaintenance}
                        onChange={(e: any) => form.setFieldValue('needMaintenance', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="needMaintenance" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="notes"
                        type="text"
                        label="Note"
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button
                        component={RouterLink}
                        variant="outlined"
                        color="secondary"
                        to={"/tooltypologies"}
                    >
                        Annulla
                    </Button>
                    <Button type="submit" variant="contained">
                        Salva
                    </Button>
                </Grid>
            </Grid>

        </Form >
    );
}

export default ToolTypologyForm;